import React, { Component } from 'react';

import { AuthContext } from "../../../components/Auth/AuthDataProvider.jsx";
import apiUtil from "../../../api/apiUtil.jsx";
import api from "../../../api/api.jsx";

import { 
  Box,
  Grid,
  InputLabel,
  Select
} from '@material-ui/core';

import CustomInput from '../../../components/CustomFields/CustomInput.jsx';
import CustomLabel from '../../../components/CustomFields/CustomLabel.jsx';
import CustomButton from '../../../components/CustomFields/CustomButton.jsx';

export class VehicleForm extends Component {
  static contextType = AuthContext;

  constructor(props){
    super(props);

    let isLoading = ((props.isLoading === true || props.isLoading === false) ? props.isLoading : false);
    let item = (props.item) ? props.item : null;
    
    let plate_no = (item && item.plate_no) ? item.plate_no : '';
    let manufacturer = (item && item.manufacturer) ? item.manufacturer : '';
    let model = (item && item.model) ? item.model : '';
    let vehicleColor = (item && item.vehicleColor) ? item.vehicleColor : '';
    let vehicleType = (item && item.vehicleType) ? item.vehicleType : '';
    let loadCapicity = (item && item.loadCapicity) ? item.loadCapicity : '';
    let engineCapacity = (item && item.engineCapacity) ? item.engineCapacity : '';

    this.state = {
        isLoading: isLoading,
        item: item,

        plate_no: plate_no,
        plate_noValidated: false,
        manufacturer: manufacturer,
        manufacturerValidated: false,
        model: model,
        modelValidated: false,
        vehicleColor: vehicleColor,
        vehicleColorValidated: false,
        vehicleType: vehicleType,
        vehicleTypeVlidated: false,
        loadCapicity: loadCapicity,
        engineCapacity: engineCapacity
    }
  }
  

  componentWillReceiveProps(nextProps) {
    if (nextProps.isLoading !== this.state.isLoading) {
        let isLoading = ((nextProps.isLoading === true || nextProps.isLoading === false) ? nextProps.isLoading : false);
        this.setState({
            isLoading: isLoading
        });
    }
    if (nextProps.item !== this.state.item) {
        let item = (nextProps.item) ? nextProps.item : null;
        this.setState({
            item: item
        });
    }
  }


  /* API */
  callCreateApi = (row, callback = null) => {
    const { accessToken } = this.context;

    this.setState({
      isLoading: true
    }, () => {
        api.create('vehicles', row, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            this.setState({
              isLoading: false,
            }, () => {
              if(callback){
                callback(data);
              }
            });
          }, (error, type) => {
            // if(error && error.email && error.email.length > 0){
            //     apiUtil.toast(error.email[0], 'warning', 'error');
            // } else if(error && error !== ''){
            //     apiUtil.toast(error, 'warning', 'error');
            // }
            
            this.setState({
              isLoading: false,
            }, () => {
              if(callback){
                callback(null);
              }
            });
          });
      });
    });
  }
  /* END API */


  /* FORM */
  setForm = () => {
    return <Box>
        <Grid container>
            <Box clone>
                <Grid item xs={12}>
                    <CustomLabel
                        label={'Vehicle Information'}
                        weight={'bold'}
                        size={'md'}
                    />
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={12}>
                    <CustomInput
                        label={'Plate Number*'}
                        placeholder={'Enter vehicle plate number'}
                        value={this.state.plate_no}
                        error={this.state.plate_noValidated}
                        required={true}
                        autoFocus={true}
                        onChange={(e) => {
                            this.setState({
                                plate_no: e.target.value,
                                plate_noValidated: (e.target.value !== '') ? false : true,
                            });
                        }}
                    />
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={12}>
                    <CustomInput
                        label={'Manufacturer*'}
                        placeholder={'Enter vehicle manufacturer'}
                        value={this.state.manufacturer}
                        error={this.state.manufacturerValidated}
                        required={true}
                        onChange={(e) => {
                            this.setState({
                                manufacturer: e.target.value,
                                manufacturerValidated: (e.target.value !== '') ? false : true,
                            });
                        }}
                    />
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={12}>
                    <CustomInput
                        label={'Model*'}
                        placeholder={'Enter vehicle Model name'}
                        value={this.state.model}
                        error={this.state.modelValidated}
                        required={true}
                        onChange={(e) => {
                            this.setState({
                                model: e.target.value,
                                modelValidated: (e.target.value !== '') ? false : true,
                            });
                        }}
                    />
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={12}>
                    <CustomInput
                        label={'Vehicle Color*'}
                        placeholder={'Enter vehicle color'}
                        value={this.state.vehicleColor}
                        error={this.state.vehicleColorValidated}
                        required={true}
                        autoFocus={true}
                        onChange={e => {
                            this.setState({
                                vehicleColor: e.target.value,
                                vehicleColorValidated: (e.target.value !== '') ? false : true
                            })
                            
                        }}
                    />
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={12}>
                    <Box className="custom-label-component">
                        <InputLabel error={this.state.vehicleTypeVlidated}>Vehicle Type *</InputLabel>
                    </Box>
                    <Select className="custom-input-component" style={{width:"100%", border: "1px solid #E0E1E4", borderRadius: "4px",padding:"", backgroundColor: 'transparent'}}
                    placeholder={'Select Vehicle Type here...'}
                    value={this.state.vehicleType}
                    error={this.state.vehicleTypeVlidated}
                    native
                    required={true}
                    disableUnderline
                    onChange={(e) => {
                        this.setState({
                            vehicleType: e.target.value,
                            vehicleTypeVlidated: (e.target.value !== '') ? false : true
                        })
                    }}
                    >
                    <option value=""> Select Vehicle type </option>
                    <option value={1}>Car</option>
                    <option value={2}>MPV</option>
                    <option value={3}>1.7m Van</option>
                    <option value={4}>2.4m Van</option>
                    <option value={5}>10 Ft Lorry</option>
                    <option value={6}>14 Ft Lorry</option>
                    <option value={7}>Walker</option>
                    </Select>
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={12}>
                    <CustomInput
                        label={<>Load Capacity <small className={'muted'}>Optional</small></>}
                        placeholder={'Enter the load capacity of the vehicle'}
                        value={this.state.loadCapicity}
                        autoFocus={true}
                        onChange={(e) => {
                            this.setState({
                                loadCapicity: e.target.value
                            })
                        }}
                    />
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={12}>
                    <CustomInput
                        label={'Engine Capacity'}
                        placeholder={'Enter the engine capacity of the vehicle'}
                        value={this.state.engineCapacity}
                        autoFocus={true}
                        onChange={(e) => {
                            this.setState({
                                engineCapacity: e.target.value
                            })
                        }}
                    />
                </Grid>
            </Box>
        </Grid>
    </Box>
  }
  
  setButtons = () => {
    return <Box>
        <Grid container alignItems={'center'} >
            <Box clone textAlign={'right'} pr={2}>
                <Grid item xs={true}>
                    <CustomButton 
                        onClick={() => {
                            if(this.props.onClose){
                                this.props.onClose();
                            }
                        }}
                    >
                        Cancel
                    </CustomButton>
                </Grid>
            </Box>
            <Box clone>
                <Grid item xs={'auto'}>
                    <CustomButton 
                        type={'submit'}
                        color={'secondary'} 
                        isLoading={this.state.isLoading}
                    >
                        {(this.state.item ? 'Edit Vehicle' : 'Add Vehicle')}
                    </CustomButton>
                </Grid>
            </Box>
        </Grid>
    </Box>
  }
  /* END FORM */


  /* SUBMIT */
  handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    this.setState({
        isLoading: true,
    });

    const form = e.currentTarget;

    this.setState({
        plate_noValidated: false,
        manufacturerValidated: false,
        modelValidated: false,
        vehicleColorValidated: false,
        vehicleTypeVlidated: false,
    });
    
    if(this.state.plate_no === ''){
      this.setState({
        plate_noValidated: true
      });
    }
    if(this.state.manufacturer === ''){
      this.setState({
        manufacturerValidated: true
      });
    }
    if(this.state.vehicleColor === ''){
        this.setState({
            vehicleColorValidated: true
        });
    }
    if(this.state.vehicleType === ''){
        this.setState({
            vehicleTypeVlidated: true
        });
    }
    if(this.state.model === ''){
      this.setState({
        modelValidated: true
      });
    }

    if (form.checkValidity() === true) {
        this.callCreateApi(this.getForm(), (data) => {
            if(data){
                if(this.props.onSave){
                    this.props.onSave((this.state.item ? true : false), data);
                }
            }
        });
        
    } else {
        this.setState({
            isLoading: false
        });
    }
  }

  
  getForm = () => {
    let data = {
        plate_no: this.state.plate_no,
        manufacturer: this.state.manufacturer,
        model: this.state.model,
        colour : this.state.vehicleColor,
        engine_capacity: parseInt(this.state.engineCapacity),
        load_capacity: parseInt(this.state.loadCapicity),
        vehicle_type_id: this.state.vehicleType
    }

    return data;
  }
  /* END SUBMIT */
      
  render() {
    return <Box>
        <form noValidate autoComplete="off" onSubmit={this.handleSubmit}>
            <Grid container>
                <Box clone pt={2} pb={2}>
                    <Grid item xs={12}>
                        {this.setForm()}
                    </Grid>
                </Box>
                <Box clone>
                    <Grid item xs={12}>
                        {this.setButtons()}
                    </Grid>
                </Box>
            </Grid>
        </form>
    </Box>
  }
}

export default VehicleForm;